import { Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const T = {
  sk: ["Vaša pečať Hall of Fame – Registered", "Ste zapísaný vo verejnom registri SauberEko®. Pečať môžete hrdo používať na sociálnych sieťach, webe či vo vizitke.", "PNG (priehľadné pozadie)", "JPG pre sociálne siete"],
  en: ["Your Hall of Fame – Registered seal", "You are listed in the public SauberEko® register. Use the seal proudly on social media, your website or business card.", "PNG (transparent)", "JPG for social media"],
  de: ["Ihr Siegel Hall of Fame – Registered", "Sie sind im öffentlichen SauberEko®-Register eingetragen. Nutzen Sie das Siegel in sozialen Netzwerken, auf Ihrer Website oder Visitenkarte.", "PNG (transparent)", "JPG für soziale Netzwerke"],
  pl: ["Twoja pieczęć Hall of Fame – Registered", "Jesteś wpisany do publicznego rejestru SauberEko®. Używaj pieczęci w mediach społecznościowych, na stronie lub wizytówce.", "PNG (przezroczyste tło)", "JPG do mediów społecznościowych"],
  fr: ["Votre sceau Hall of Fame – Registered", "Vous êtes inscrit au registre public SauberEko®. Utilisez le sceau sur les réseaux sociaux, votre site ou votre carte de visite.", "PNG (fond transparent)", "JPG pour les réseaux sociaux"],
};
const btn = "inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] px-4 py-2 text-sm hover:bg-[#D4AF37] hover:text-black transition-colors";

export default function RegisteredSeal({ lang }) {
  const t = T[lang] || T.sk;
  const url = (ext) => `${API}/download/facebook/saubereko-hall-of-fame-registered.${ext}`;
  return (
    <div className="border border-[#D4AF37]/30 bg-[#0a0a0a] p-6 mb-6 flex flex-col sm:flex-row gap-6 items-center" data-testid="profile-registered-seal">
      <img src="/saubereko-hall-of-fame-registered.png" alt="SauberEko® Hall of Fame – Registered" className="w-28 h-28 shrink-0" />
      <div>
        <h3 className="font-display text-xl">{t[0]}</h3>
        <p className="text-white/50 text-sm mt-1 mb-4">{t[1]}</p>
        <div className="flex flex-wrap gap-3">
          <a href={url("png")} className={btn} data-testid="seal-download-png"><Download size={14} /> {t[2]}</a>
          <a href={url("jpg")} className={btn} data-testid="seal-download-jpg"><Download size={14} /> {t[3]}</a>
        </div>
      </div>
    </div>
  );
}
